import { render, staticRenderFns } from "./articleLabels.vue?vue&type=template&id=085af029&"
import script from "./articleLabels.vue?vue&type=script&lang=js&"
export * from "./articleLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports